import React, { useState, useEffect } from 'react';
import { 
  Paper, 
  Typography, 
  Box,
  IconButton,
  MobileStepper 
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

const testimonials = [
  {
    quote: "Hire-Best.ai has revolutionized our recruitment process. We've reduced hiring time by 60% and improved candidate quality significantly.",
    author: "V.N",
    role: ""
  },
  {
    quote: "The AI-driven candidate matching is incredible. We found perfect fits for hard-to-fill positions in record time.",
    author: "A.B",
    role: ""
  },
  {
    quote: "Our time-to-hire dropped from weeks to days. The platform's efficiency and accuracy are game-changing for our recruitment needs.",
    author: "P.B",
    role: ""
  },
];

const TestimonialSection = styled(Paper)(({ theme }) => ({
  background: 'transparent',
  color: '#475569', // slate-600 for main text
  padding: theme.spacing(8),
  margin: theme.spacing(12, 0),
  textAlign: 'center',
  borderRadius: theme.spacing(2),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.05)',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4),
    margin: theme.spacing(8, 2),
  },
}));

const TestimonialCarousel = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const maxSteps = testimonials.length;

  useEffect(() => {
    const timer = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveStep((prevStep) => (prevStep + 1) % maxSteps);
        setIsTransitioning(false);
      }, 500);
    }, 4000);

    return () => clearInterval(timer);
  }, [maxSteps]);

  return (
    <Box 
      sx={{ 
        maxWidth: 1500, 
        flexGrow: 1, 
        mx: 'auto',
        position: 'relative',
        mt: 16, 
      }}
    >
      <TestimonialSection elevation={3}>
        <Box 
          sx={{ 
            minHeight: { xs: '200px', md: '180px' },
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            transition: 'opacity 0.5s ease-in-out',
            opacity: isTransitioning ? 0 : 1
          }}
        >
          <Typography
            variant="h6"
            component="blockquote"
            sx={{
              fontSize: { xs: '1.1rem', md: '1.3rem' },
              fontStyle: 'italic',
              mb: 3
            }}
          >
            "{testimonials[activeStep].quote}"
          </Typography>
          <Typography
            variant="subtitle1"
            component="cite"
            sx={{
              opacity: 0.9,
              fontSize: { xs: '0.9rem', md: '1rem' },
            }}
          >
            - {testimonials[activeStep].author}, {testimonials[activeStep].role}
          </Typography>
        </Box>

        <IconButton
          sx={{
            position: 'absolute',
            left: { xs: 8, md: 16 },
            top: '50%',
            transform: 'translateY(-50%)',
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.2)',
            },
            color: 'black',
          }}
          onClick={() => setActiveStep((prevStep) => (prevStep - 1 + maxSteps) % maxSteps)}
        >
          <KeyboardArrowLeft />
        </IconButton>

        <IconButton
          sx={{
            position: 'absolute',
            right: { xs: 8, md: 16 },
            top: '50%',
            transform: 'translateY(-50%)',
            bgcolor: 'rgba(255, 255, 255, 0.1)',
            '&:hover': {
              bgcolor: 'rgba(255, 255, 255, 0.2)',
            },
            color: 'black',
          }}
          onClick={() => setActiveStep((prevStep) => (prevStep + 1) % maxSteps)}
        >
          <KeyboardArrowRight />
        </IconButton>
      </TestimonialSection>
    </Box>
  );
};

export default TestimonialCarousel;
